import { render, staticRenderFns } from "./InterfaceWeb.vue?vue&type=template&id=674a55af&scoped=true&"
import script from "./InterfaceWeb.vue?vue&type=script&lang=js&"
export * from "./InterfaceWeb.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "674a55af",
  null
  
)

export default component.exports